import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useUtility, Stack } from '@hub-la/design-system';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { alpha } from '@mui/system';

const Lock = ({
  fullSize: _fullSize = false
}) => {
  const {
    palette
  } = useUtility();
  return jsx(Stack, Object.assign({
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 1,
    p: 1,
    left: _fullSize ? 0 : 8,
    top: _fullSize ? 0 : 8,
    width: "100%",
    height: "100%",
    maxHeight: _fullSize ? '100%' : 36,
    maxWidth: _fullSize ? '100%' : 40,
    bgcolor: alpha(palette('background'), 0.5),
    style: {
      backdropFilter: 'blur(5px)'
    }
  }, {
    children: jsx(LockOutlinedIcon, {})
  }));
};

export { Lock as default };
